import type { InjectionKey } from "vue";

export const isChooseNewDeviceStepAvailableKey = Symbol(
    "isChooseNewDeviceStepAvailableKey",
) as InjectionKey<boolean>;

export const shadowRootKey = Symbol() as InjectionKey<ShadowRoot>;

export const WIDGET_STYLE_ID = "tiw-widget-styles";
